/**
 * Member-portal side of meetings (TRUS-691): the member API in context (member
 * token, never the staff client) and the ?meeting= host. Members see the
 * meetings they are invited to, RSVP and join; they never schedule.
 */

import React from 'react';
import { getMemberData } from '@/lib/memberAuth';
import { memberMeetingsApi } from '@/services/meetingsApi';
import { MeetingsHost } from './MeetingsHost';
import { MeetingsApiContext } from './useMeetings';

/** The signed-in member's id, when the portal stored it. */
export function currentMemberId(): number | null {
  const d = getMemberData();
  const id = Number(d?.member_id ?? d?.id);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function MemberMeetingsProvider({ children }: { children: React.ReactNode }) {
  return (
    <MeetingsApiContext.Provider value={memberMeetingsApi}>
      {children}
      <MeetingsHost currentMemberId={currentMemberId()} />
    </MeetingsApiContext.Provider>
  );
}
